import { useEffect } from 'react';

const SEO = ({
  title,
  description,
  keywords,
  canonical,
  ogImage = '/images/favicon.webp',
  ogType = 'website',
  jsonLd,
  noindex = false,
}) => {
  const baseUrl = 'https://regal-play.com';
  const fullTitle = title ? `${title} | Regal Play` : 'Regal Play - Expert UK Casino Reviews & Exclusive Bonus Offers';
  const fullDescription = description || 'Discover the best UK online casinos with Regal Play. Expert reviews, exclusive bonuses, and comprehensive guides to help you find trusted casino platforms. 18+ only. Play responsibly.';
  const fullKeywords = keywords || 'UK online casinos, casino reviews, casino bonuses, online gambling UK, casino guides, best UK casinos, casino comparison';
  const canonicalUrl = canonical ? `${baseUrl}${canonical}` : baseUrl;
  const ogImageUrl = ogImage.startsWith('http') ? ogImage : `${baseUrl}${ogImage}`;

  useEffect(() => {
    // Update document title
    document.title = fullTitle;

    // Update or create meta tags
    const updateMetaTag = (name, content, attribute = 'name') => {
      let element = document.querySelector(`meta[${attribute}="${name}"]`);
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute, name);
        document.head.appendChild(element);
      }
      element.setAttribute('content', content);
    };

    // Primary Meta Tags
    updateMetaTag('title', fullTitle);
    updateMetaTag('description', fullDescription);
    updateMetaTag('keywords', fullKeywords);
    updateMetaTag('author', 'Regal Play');
    updateMetaTag('robots', noindex ? 'noindex, nofollow' : 'index, follow');
    updateMetaTag('language', 'English');
    updateMetaTag('revisit-after', '7 days');
    updateMetaTag('theme-color', '#0A0A0A');
    
    // Open Graph Meta Tags
    updateMetaTag('og:type', ogType, 'property');
    updateMetaTag('og:url', canonicalUrl, 'property');
    updateMetaTag('og:title', fullTitle, 'property');
    updateMetaTag('og:description', fullDescription, 'property');
    updateMetaTag('og:image', ogImageUrl, 'property');
    updateMetaTag('og:site_name', 'Regal Play', 'property');
    updateMetaTag('og:locale', 'en_GB', 'property');
    
    // Twitter Meta Tags
    updateMetaTag('twitter:card', 'summary_large_image', 'property');
    updateMetaTag('twitter:url', canonicalUrl, 'property');
    updateMetaTag('twitter:title', fullTitle, 'property');
    updateMetaTag('twitter:description', fullDescription, 'property');
    updateMetaTag('twitter:image', ogImageUrl, 'property');
    
    // Geographic Meta Tags
    updateMetaTag('geo.region', 'GB');
    updateMetaTag('geo.placename', 'London');
    updateMetaTag('geo.position', '51.5074;-0.1278');
    updateMetaTag('ICBM', '51.5074, -0.1278');
    
    // DC Meta Tags
    updateMetaTag('DC.title', fullTitle);
    updateMetaTag('DC.creator', 'Regal Play');
    updateMetaTag('DC.subject', 'UK Online Casinos, Casino Reviews, Gambling Guides');
    updateMetaTag('DC.publisher', 'Regal Play');
    updateMetaTag('DC.date', '2025-12-02');

    // Update canonical link
    let canonicalLink = document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', canonicalUrl);

    // Add JSON-LD structured data
    if (jsonLd) {
      // Remove existing JSON-LD scripts from this component
      const existingScripts = document.querySelectorAll('script[data-seo-jsonld]');
      existingScripts.forEach(script => script.remove());

      // Add new JSON-LD script
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-seo-jsonld', 'true');
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }

    // Cleanup function
    return () => {
      // Optional: cleanup can be done here if needed
    };
  }, [fullTitle, fullDescription, fullKeywords, canonicalUrl, ogImageUrl, ogType, jsonLd, noindex]);

  return null;
};

export default SEO;

